<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.228 4L12.2573 6.90082C12.2628 8.00981 11.3649 8.91154 10.2559 8.91074L5.75928 8.90751M7.11239 6.59443L4.5 8.98863L6.98409 11.3207" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
